import { Injectable } from '@angular/core';
import { DROPDOWN_LABELS } from '../../constants/layout.constants';

/**
 * Service for managing dropdown labels
 * Follows Open/Closed Principle - extensible without modification
 */
@Injectable({
  providedIn: 'root'
})
export class DropdownLabelService {
  private readonly labelMap: Record<string, string> = {
    'premix': DROPDOWN_LABELS.PREMIX,
    'jarmix': DROPDOWN_LABELS.JARMIX,
    'ats': DROPDOWN_LABELS.ATS,
    'technical': DROPDOWN_LABELS.TECHNICAL,
    'program-builder': DROPDOWN_LABELS.PROGRAM_BUILDER,
    'resistance-management': DROPDOWN_LABELS.RESISTANCE_MANAGEMENT,
    'admin-premix': DROPDOWN_LABELS.ADMIN_PREMIX,
    'admin-technical': DROPDOWN_LABELS.ADMIN_TECHNICAL,
    'admin-resistance-management': DROPDOWN_LABELS.ADMIN_RESISTANCE_MANAGEMENT
  };

  /**
   * Gets display text for dropdown item
   */
  getDisplayText(key: string, fallbackTitle: string): string {
    return this.labelMap[key] || fallbackTitle;
  }

  /**
   * Allows adding new labels without modifying existing code
   */
  addLabel(key: string, label: string): void {
    this.labelMap[key] = label;
  }

  /**
   * Gets all available labels
   */
  getAllLabels(): Record<string, string> {
    return { ...this.labelMap };
  }
}
